import { useCallback } from 'react';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { COMPLETIONS_MUTATION, fillContent } from './utils/promptUtils';

function useCompletionsMutation() {
  const { accountUuid } = useAuthentication();
  const [fetchCompletionsMutation, {
    data, loading, errors, error
  }] = useMutation(COMPLETIONS_MUTATION, {
    noThrow: true,
    useCache: true
  });

  useError(errors);

  const fetchCompletions = useCallback((promptData, fillData) => {
    const {
      uuid,
      systemContent,
      userContent,
      structuredOutput,
      maxCompletionTokens,
      temperature,
      model
    } = promptData?.findPrompt || {};
    fetchCompletionsMutation({
      variables: {
        model,
        temperature,
        maxCompletionTokens,
        metadata: {
          promptUuid: uuid,
          accountUuid
        },
        messages: [{
          role: 'system',
          content: systemContent
        },
        {
          role: 'user',
          content: fillContent(fillData, userContent)
        }],
        responseFormat: {
          name: 'structured',
          ...structuredOutput
        }
      }
    });
  }, [accountUuid, fetchCompletionsMutation]);

  return {
    fetchCompletions,
    data,
    loading,
    errors,
    error
  };
}

export { useCompletionsMutation };
